export default "__VITE_ASSET__ZKcHG0pg__"